export default "__VITE_ASSET__xt16rqwK__"